import { render, staticRenderFns } from "./AdminTranslation.vue?vue&type=template&id=887ed9b8&scoped=true"
import script from "./AdminTranslation.ts?vue&type=script&lang=ts&external"
export * from "./AdminTranslation.ts?vue&type=script&lang=ts&external"
import style0 from "./AdminTranslation.scss?vue&type=style&index=0&id=887ed9b8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887ed9b8",
  null
  
)

export default component.exports